// The @Avida system user id (reactions mirrored from Slack land under this key).
const AVIDA_SYSTEM_USER_ID = 'avida-system';

// Sentinel reaction value used by @Avida; rendered as the Avida avatar instead of an emoji glyph.
const AVIDA_REACTION_SENTINEL = ':avidaicon:';

export {
  AVIDA_SYSTEM_USER_ID,
  AVIDA_REACTION_SENTINEL,
};
